import React, { Fragment } from 'react';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import './InstanceData.css';

const InstanceData = (props) => {
    if (!props.instance) {
        return <p>Loading</p>;
    }
    return (
        <Fragment>
            <CardMedia
                className="instanceLogo"
                image={props.instance.image}
                title={props.instance.name}
            />

            {props.instance.message.title &&
                <Card className="message">
                    <CardActionArea>
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2" className="centered">
                                {props.instance.message.title}
                            </Typography>
                            <Typography component="p" className="centered">
                                {props.instance.message.content}
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
            }
        </Fragment>
    );
};

export default InstanceData;

